export const getYawFromQuaternion = (q: { x: number; y: number; z: number; w: number }) => {
  const yaw = Math.atan2(2.0 * (q.x * q.y + q.w * q.z), q.w * q.w + q.x * q.x - q.y * q.y - q.z * q.z)
  return 90 - (yaw * 180) / Math.PI
}
